import React, { Fragment, useEffect, useMemo, useState } from 'react'
import styles from './pupils.styles'
import injectSheet from 'react-jss'
import Paper from 'pobble-components/dist/paper'
import ContentHolder from '../../content-holder/content-holder'
import PupilsComponent from '../../pupils-component/pupils-component.container'
import LoadingScreen from './loading-screen/loading-screen'
import SetAgeGroupDialog from './dialogs/set-age-group/set-age-group.container'
import AddToGroupDialog from './dialogs/add-to-group/add-to-group.container'
import RemoveFromGroupDialog from './dialogs/remove-from-group/remove-from-group.container'
import PupilsBulkAction from './pupils-bulk-action/pupils-bulk-action.container'
import { PrintPasscodesDialog } from '../../print-passcodes/print-passcodes'
import PupilsContext from './pupils.context'
import { printPasscodesStyles } from '../../print-passcodes/print-passcodes.styles'

const Pupils = ({
  classes,
  showLoadingScreen,
  showPupilsComponent,
  onMount
}) => {
  useEffect(() => {
    onMount()
  }, []) //eslint-disable-line

  const [printPasscodesState, setPrintPasscodesState] = useState({
    open: false,
    ids: []
  })

  const contextValue = useMemo(
    () => {
      return {
        openPasscodesDialog: ids => setPrintPasscodesState({ open: true, ids })
      }
    },
    [setPrintPasscodesState]
  )

  return (
    <PupilsContext.Provider value={contextValue}>
      <ContentHolder className={classes.pageHolder}>
        <Paper>
          {showLoadingScreen && <LoadingScreen />}
          {showPupilsComponent && (
            <Fragment>
              <PupilsComponent />
              <SetAgeGroupDialog />
              <AddToGroupDialog />
              <RemoveFromGroupDialog />
            </Fragment>
          )}
        </Paper>
        <PupilsBulkAction />
        <PrintPasscodesDialog
          isOpen={printPasscodesState.open}
          ids={printPasscodesState.ids}
          requestClose={() =>
            setPrintPasscodesState({ ...printPasscodesStyles, open: false })
          }
        />
      </ContentHolder>
    </PupilsContext.Provider>
  )
}

export default injectSheet(styles)(Pupils)
